import LanguageSelector from './footer/languageSelector';

new LanguageSelector();